module.exports = __webpack_public_path__ + "img/no-video.c265f5e0.svg";